const isGifImageUrl = (url: string): boolean => {
    return url?.toLowerCase().endsWith('.gif') || false;
};

export { isGifImageUrl };
